(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qc-product-spread"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
  if(!event.target.matches('[data-qcx-variant]'))return;
  const root=event.target.closest('[data-qcx]'),option=event.target.selectedOptions[0],button=root.querySelector('[data-qcx-submit]');
  root.querySelector('[data-qcx-price]').textContent=option.dataset.price;
  button.disabled=option.dataset.available!=='true';
  button.querySelector('span').textContent=button.disabled?button.dataset.sold:button.dataset.label;
});
  } catch(e) { console.error(e); }
})();

})();
